import { HeartFilled } from "@ant-design/icons";
import { useEffect, useState, useRef } from "react";
import {
  Avatar,
  Card,
  Image,
  Skeleton,
  Tooltip,
  Row,
  Popover,
  Typography,
  message,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import { useMobxStores } from "../../stores/stores";
import { useNavigate } from "react-router-dom";
import { keycloak } from "../../utils/keycloak";
import UserPreview from "../profile/UserPreview";
import DownloadIcon from "../../assets/download-icon.png";
import DownloadIconGrey from "../../assets/download-icon-white.png";
import PlusIcon from "../../assets/plus-icon.png";
import PlusIconWhite from "../../assets/plus-icon-white.png";
import { isMoocLink, isRepositoryLink } from "../utils/urlValidators";
import { handleDownload } from "../../utils/itemButtonActions";
import "./ItemPreview.css";

const { Meta } = Card;

const ItemPreview = (props) => {
  const [isHover, setIsHover] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const [isHoverPlusIcon, setIsHoverPlusIcon] = useState(false);
  const [isActivePlusIcon, setIsActivePlusIcon] = useState(false);

  const [isHoverBuyNow, setIsHoverBuyNow] = useState(false);
  const [isActiveBuyNow, setIsActiveBuyNow] = useState(false);
  const { styleStore, marketplaceStore, userStore } = useMobxStores();
  const navigate = useNavigate();

  const isLong = props.item.name.length > 17;

  const content = (
    <div
      style={{
        maxWidth: "192px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "20px",
        fontWeight: "500",
        color: "#000080",
      }}
    >
      {props.item.name}
    </div>
  );

  const nft = marketplaceStore.nftArray?.find(
    (nft) => nft.id === props.item.nft,
  );

  const onUsernameClick = (username) => {
    navigate(`../portfolio/${username}`);
  };

  const OnUsernameMouseOver = (username) => {
    userStore.GetUserDetails(username);
  };

  const isItemInCart = (id) => {
    return marketplaceStore.cart.items.includes(id);
  };

  const onAddtoCart = async (item) => {
    marketplaceStore.setCartCurrency(props.item.chainid);

    try {
      const listings = await marketplaceStore.GetListingsById(item.nft);
      if (!isItemInCart(item.id)) {
        let values = { ...marketplaceStore.cart };
        values.items.push(item.id);

        let purchaseInfo = [...(values.purchase_info || [])];
        purchaseInfo.push({
          listing: listings[0]?.id,
          quantity: 1,
        });

        marketplaceStore.UpdateCart({
          items: values.items,
          purchase_info: purchaseInfo,
        });

        message.success("Item added to cart");
      } else {
        message.warning("Item already in cart");
      }
    } catch (error) {
      message.error("Failed to add to cart");
    }
  };

  const onAddtoWishlist = (id) => {
    let values = marketplaceStore.wishlist;
    values.items.push(id);
    marketplaceStore.UpdateWishlist(values);
  };

  const onRemoveFromWishlist = (id) => {
    let values = marketplaceStore.wishlist;
    for (let i = 0; i < values.items.length; i++) {
      if (values.items[i] === id) {
        values.items.splice(i, 1);
        break;
      }
    }
    marketplaceStore.UpdateWishlist(values);
  };

  const getAllowAddToCart = () => {
    const cartNft = marketplaceStore.nftArray.find(
      (nft) => nft.id === marketplaceStore.cart?.items_list?.[0]?.nft,
    );

    return (
      nft &&
      !nft.legacy &&
      nft.listed &&
      nft.supply === 1 &&
      !marketplaceStore.cart?.items.some((item) => item === props.item.id) &&
      (marketplaceStore.cart?.items_list?.length === 0 ||
        cartNft?.chainid === nft?.chainid)
    );
  };

  const requireAuth = (onAuthenticated) => {
    if (keycloak.authenticated) {
      onAuthenticated();
    } else {
      Modal.confirm({
        title: "Sign in required",
        content:
          "You are not allowed to perform this action. You need to sign in first.",
        okText: "Sign in",
        cancelText: "Cancel",
        onOk: () => keycloak.login({ redirectUri: window.location.href }),
      });
    }
  };

  const handleSimpleBuyNFT = async (item) => {
    const metamaskData = localStorage.getItem("metaMask");
    if (!metamaskData) {
      message.error("Please log in to Metamask first");
      return;
    }

    marketplaceStore.setBuyInProgress(true);
    try {
      await marketplaceStore.GetListingsById(item.nft);
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: `0x${item.chainid.toString(16)}` }],
      });
      let values = {
        account: metamaskData,
        listing: marketplaceStore.listings[0].id,
        quantity: 1,
      };
      await marketplaceStore.BuyNFT(item.nft, values);
      await marketplaceStore.UpdateNFT(nft?.id, {
        listed: false,
      });
    } catch (error) {
      console.error(error);
    } finally {
      marketplaceStore.setBuyInProgress(false);
    }
  };

  return marketplaceStore.fetchingMarketplaceItems ? (
    <Card
      key={props.item.id}
      style={{
        width: 240,
        marginTop: 16,
      }}
      extra={
        <div style={{ marginRight: "8px" }}>
          <HeartFilled style={{ fontSize: "24px", color: "whitesmoke" }} />
        </div>
      }
    >
      <Skeleton loading avatar active>
        <Meta
          avatar={
            <Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel&key=2" />
          }
          title="Card title"
          description="This is the description"
        />
      </Skeleton>
    </Card>
  ) : (
    <>
      <Card
        title={
          <Row>
            <div
              onClick={(e) => {
                e.stopPropagation();
                onUsernameClick(props.item.owner_name);
              }}
              onMouseOver={() => OnUsernameMouseOver(props.item.owner_name)}
            >
              <Popover
                style={{ backgroundColor: "transparent" }}
                placement={"topLeft"}
                content={<UserPreview />}
              >
                {props.item.owner_name}
              </Popover>
            </div>
          </Row>
        }
        key={props.item.id}
        onClick={(e) => {
          navigate(`/marketplace/${props.item.id}`);
        }}
        className="item-preview-card"
        hoverable={true}
        cover={
          <div
          // onClick={(e) => e.stopPropagation()
          // }
          >
            <Image
              style={{
                height: "186px",
                objectFit: "cover",
                opacity: 1,
              }}
              alt={props.item.type}
              src={props.item.display_image.thumbnail}
              preview={false}
              width={"100%"}
            />
          </div>
        }
        extra={[
          <Tooltip
            title={
              marketplaceStore.wishlist.items.includes(props.item.id)
                ? "Remove this item from your wishlist!"
                : "Add this item to your wishlist!"
            }
          >
            <HeartFilled
              onClick={(e) => {
                e.stopPropagation();
                if (keycloak.authenticated) {
                  marketplaceStore.wishlist.items.includes(props.item.id)
                    ? onRemoveFromWishlist(props.item.id)
                    : onAddtoWishlist(props.item.id);
                } else {
                  Modal.confirm({
                    title: "Sign in required",
                    content:
                      "You are not allowed to perform this action. You need to sign in first.",
                    okText: "Sign in",
                    cancelText: "Cancel",
                    onOk: () =>
                      keycloak.login({ redirectUri: window.location.href }),
                  });
                }
              }}
              style={{
                fontSize: "24px",
                color: marketplaceStore.wishlist.items.includes(props.item.id)
                  ? styleStore.primaryColor
                  : "gray",
                marginLeft: "4px",
              }}
            />
          </Tooltip>,
        ]}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <div
            style={{
              fontSize: "20px",
              fontWeight: "500",
              color: "#000080",
              maxWidth: "192px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {props.item.name}
          </div> */}
          {isLong ? (
            <Tooltip
              title={
                <div
                  style={{
                    maxWidth: "90vw", // Tooltip can be almost full screen
                    whiteSpace: "normal", // Allow wrapping in tooltip
                    fontSize: "16px",
                  }}
                >
                  {props.item.name}
                </div>
              }
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "500",
                  color: "#000080",
                  maxWidth: "192px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {props.item.name}
              </div>
            </Tooltip>
          ) : (
            <div
              style={{
                fontSize: "20px",
                fontWeight: "500",
                color: "#000080",
                // maxWidth: "192px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {props.item.name}
            </div>
          )}

          {nft?.legacy && (
            <div
              style={{
                background: "#000080",
                boxShadow: " 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "50px",
                color: "white",
                fontSize: "12px",
                padding: "2px 12px",
              }}
            >
              legacy
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              height: "42px",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "end",
              justifyContent: "space-between",
            }}
          >
            {nft && (
              <div>
                <Typography
                  style={{
                    textAlign: "start",
                    height: "20px",
                    fontWeight: "600",
                    color: "rgba(95, 95, 107, 0.67)",
                    fontSize: "14px",
                  }}
                >
                  {nft.supply > 1 ? "Editions" : "Price"}
                </Typography>
                {nft.supply > 1 ? (
                  <Typography
                    style={{
                      textAlign: "start",
                      height: "20px",
                      fontWeight: "500",
                      color: "#000080",
                      fontSize: "14px",
                    }}
                  >
                    {nft.supply}
                  </Typography>
                ) : (
                  <Typography
                    style={{
                      textAlign: "start",
                      height: "20px",
                      fontWeight: "600",
                      color: "#000080",
                      fontSize: "14px",
                    }}
                  >
                    {nft.price}
                    {nft.chainid === 11155111 ? "ETH" : "MATIC"}
                  </Typography>
                )}
              </div>
            )}
            {nft?.supply > 1 && (
              <div
                style={{
                  color: "white",
                  fontSize: "12px",
                  padding: "2px 12px",
                  background:
                    "linear-gradient(105.4deg, #000080 0%, #2A93D3 126.13%)",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  borderRadius: "50px",
                  height: "fit-content",
                }}
              >
                limited edition
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "rgba(214, 211, 211, 0.35)",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              borderRadius: "10px",
              height: "32px",
            }}
          >
            {!props.item.nft &&
              ((props.item.type === "software" &&
                isRepositoryLink(props.item.source_media)) ||
                (props.item.type === "MOOC" &&
                  isMoocLink(props.item.source_media))) && (
                <div
                  // style={{
                  //   color: "#000080",
                  //   fontSize: "16px",
                  //   fontWeight: "600",
                  //   width: "98px",
                  //   textAlign: "center",
                  // }}

                  style={{
                    color: isActive ? "white" : isHover ? "#ffffff" : "#000080",
                    backgroundColor: isActive
                      ? "#000080"
                      : isHover
                        ? "#000080"
                        : "transparent",
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "106px",
                    textAlign: "center",
                    cursor: "pointer",
                    borderRadius: "10px",
                    padding: "2px 12px",
                    transition: "0.2s ease",
                  }}
                  onMouseEnter={() => setIsHover(true)}
                  onMouseLeave={() => {
                    setIsHover(false);
                    setIsActive(false);
                  }}
                  onMouseDown={() => setIsActive(true)}
                  onMouseUp={() => setIsActive(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    requireAuth(() => window.open(props.item.source_media));
                  }}
                >
                  {isRepositoryLink(props.item.source_media)
                    ? "Repository"
                    : "MOOC"}
                </div>
              )}
            {nft?.supply === 1 && nft.listed && (
              <div
                style={{
                  // color: "#000080",
                  color: isActiveBuyNow
                    ? "white"
                    : isHoverBuyNow
                      ? "#ffffff"
                      : "#000080",
                  backgroundColor: isActiveBuyNow
                    ? "#000080"
                    : isHoverBuyNow
                      ? "#000080"
                      : "transparent",
                  fontSize: "16px",
                  fontWeight: "600",
                  width: "92px",
                  textAlign: "center",

                  cursor: "pointer",
                  borderRadius: "10px 10px 10px 10px",
                  padding: "2px 12px",
                  transition: "0.2s ease",
                }}
                // style={{

                //   width: "48px",
                //   height: "32px",
                //   boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                //   // backgroundColor: "#d6d3d359",
                //   borderRadius: "10px",
                //   display: "flex",
                //   justifyContent: "center",
                //   alignItems: "center",
                // }}
                onMouseEnter={() => setIsHoverBuyNow(true)}
                onMouseLeave={() => {
                  setIsHoverBuyNow(false);
                  setIsActiveBuyNow(false);
                }}
                onMouseDown={() => setIsActiveBuyNow(true)}
                onClick={(e) => {
                  e.stopPropagation();
                  requireAuth(() => handleSimpleBuyNFT(props.item));
                }}
              >
                Buy now
              </div>
            )}
            {getAllowAddToCart() && (
              <div
                style={{
                  width: "48px",
                  height: "32px",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  backgroundColor: "#d6d3d359",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: isActivePlusIcon
                    ? "white"
                    : isHoverPlusIcon
                      ? "#ffffff"
                      : "#000080",
                  backgroundColor: isActivePlusIcon
                    ? "#000080"
                    : isHoverPlusIcon
                      ? "#000080"
                      : "transparent",
                  transition: "0.2s ease",
                }}
                // style={{
                //   // color: "#000080",
                //   color: isActive ? "white" : isHover ? "#ffffff" : "#000080",
                //   backgroundColor: isActive
                //     ? "#000080"
                //     : isHover
                //     ? "#000080"
                //     : "transparent",
                //   fontSize: "16px",
                //   fontWeight: "600",
                //   width: "92px",
                //   textAlign: "center",

                //   cursor: "pointer",
                //   borderRadius: "10px 10px 10px 10px",
                //   padding: "2px 12px",
                //   transition: "0.2s ease",
                // }}

                onMouseEnter={() => setIsHoverPlusIcon(true)}
                onMouseLeave={() => {
                  setIsHoverPlusIcon(false);
                  setIsActivePlusIcon(false);
                }}
                onMouseDown={() => setIsActivePlusIcon(true)}
                onClick={(e) => {
                  e.stopPropagation();
                  requireAuth(() => onAddtoCart(props.item));
                }}
              >
                <img
                  src={isHoverPlusIcon ? PlusIconWhite : PlusIcon}
                  alt="plus icon"
                  style={{ width: "12px" }}
                />
              </div>
            )}
          </div>
          {!props.item.nft &&
            !isRepositoryLink(props.item.source_media) &&
            !isMoocLink(props.item.source_media) && (
              <div
                // style={{
                //   width: "48px",
                //   height: "32px",
                //   boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                //   backgroundColor: "#d6d3d359",
                //   borderRadius: "10px",
                //   display: "flex",
                //   justifyContent: "center",
                //   alignItems: "center",
                // }}
                style={{
                  color: isActive ? "white" : isHover ? "#ffffff" : "#000080",
                  backgroundColor: isActive
                    ? "#000080"
                    : isHover
                      ? "#000080"
                      : "transparent",
                  width: "48px",
                  height: "32px",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  // backgroundColor: "#d6d3d359",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => {
                  setIsHover(false);
                  setIsActive(false);
                }}
                onMouseDown={() => setIsActive(true)}
                onClick={(e) => {
                  e.stopPropagation();
                  requireAuth(() => handleDownload(props.item.source_media));
                }}
              >
                <img
                  src={isHover ? DownloadIconGrey : DownloadIcon}
                  alt="download"
                />
              </div>
            )}
        </div>
      </Card>
    </>
  );
};

export default observer(ItemPreview);
